import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, StyleProps, Text, Tooltip } from '@bonusly/design-system';

import { useCounterText } from './hooks/use-counter-text';
import { useCounterTooltipText } from './hooks/use-counter-tooltip-text';
import { useUniqueReactions } from './hooks/use-unique-reactions';
import { useReactionContext } from './reaction-detail-context';
import { ReactionStack } from './reaction-stack';

interface ReactionCounterProps extends StyleProps {
	onClick?: VoidFunction;
}

export const ReactionCounter: FC<ReactionCounterProps> = (props) => {
	const { bonus } = useReactionContext();
	const { t } = useTranslation('recognition');
	const stack = useUniqueReactions(bonus);
	const text = useCounterText(bonus);
	const tooltip = useCounterTooltipText(bonus);

	if (!bonus.reactions.length) {
		return null;
	}

	return (
		<Flex as="button" aria-label={t('reactions.counter.view_all_label') ?? ''} {...props}>
			<ReactionStack reactions={stack} />
			<Tooltip label={tooltip} whiteSpace="pre-line">
				<Text as="span" color="gray.600" fontSize="md" fontWeight="normal" ml={2} _hover={{ textDecor: 'underline' }}>
					{text}
				</Text>
			</Tooltip>
		</Flex>
	);
};
